import { Component, OnInit, Input } from "@angular/core";
import { Currency } from "../../../shared/enums";
import { User } from "../../../shared/models/user";
import { ManagerService } from "../../../core/services/manager.service";
import { MainService } from "../../main.service";
import { ENavItem } from "../../nav/nav-item-type";

@Component({
  selector: "app-lobby-title",
  templateUrl: "./lobby-title.component.html",
  styleUrls: ["./lobby-title.component.scss"],
})
export class LobbyTitleComponent implements OnInit {
  @Input() user: User;
  @Input() brand: string = "cantobyte";

  currency = Currency;

  constructor(
    private managerService: ManagerService,
    private mainService: MainService,
  ) {}

  ngOnInit(): void {}

  openCashier() {
    this.managerService.setActiveTab(ENavItem.Cashier);

    this.mainService.toggleSidenav(false, false);
  }
}
